/// <reference path="./cut.d.ts" />
import { GUtil } from '../gutil';
import { PageGen, PdfSize, PdfUnit } from '../pdf';
import { PdfPen, PdfBrush, PdfRect, PdfPoint } from '../pdf';

PageGen.prototype.cutCircle = function (point: PdfPoint, cross?: boolean): void {
  const r = PdfUnit.FromMillimeters(5);
  const rect = PdfRect.circle(point, r);

  this.drawEllipse(GUtil.cutPen, null, rect);

  if (cross) {
    this.drawLine(
      GUtil.cutPen,
      new PdfPoint(point.x, rect.top),
      new PdfPoint(point.x, rect.bottom)
    );
    this.drawLine(
      GUtil.cutPen,
      new PdfPoint(rect.left, point.y),
      new PdfPoint(rect.right, point.y)
    );
  }
};

PageGen.prototype.cutCross = function (
  point: PdfPoint,
  horizontal = true,
  vertical = true
): void {
  if (horizontal) {
    this.drawLine(
      GUtil.cutPen,
      new PdfPoint(0, point.y),
      new PdfPoint(this.page.getWidth(), point.y)
    );
  }

  if (vertical) {
    this.drawLine(
      GUtil.cutPen,
      new PdfPoint(point.x, 0),
      new PdfPoint(point.x, this.page.getHeight())
    );
  }
};

PageGen.prototype.cutRectangle = function (rect: PdfRect): void {
  this.drawLine(
    GUtil.cutPen,
    new PdfPoint(0, rect.top),
    new PdfPoint(this.page.getWidth(), rect.top)
  );
  this.drawLine(
    GUtil.cutPen,
    new PdfPoint(0, rect.bottom),
    new PdfPoint(this.page.getWidth(), rect.bottom)
  );

  this.drawLine(
    GUtil.cutPen,
    new PdfPoint(rect.left, 0),
    new PdfPoint(rect.left, this.page.getHeight())
  );
  this.drawLine(
    GUtil.cutPen,
    new PdfPoint(rect.right, 0),
    new PdfPoint(rect.right, this.page.getHeight())
  );
};
